import img6 from '../.././Image/img6.jpg'
import img7 from '../.././Image/img7.PNG'
import img8 from '../.././Image/img8---.jpg'
import img17 from '../.././Image/IMG_3189.PNG'


function Branding() {
    return (
        <>
            <div className="inline-grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 justify-center place-items-center">

                <div className="overflow-hidden rounded-lg shadow-lg hover:shadow-xl transition-shadow w-[300px] h-[300px]">
                    <img
                        src={img17}
                        className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
                    />
                </div>

                 <div className="overflow-hidden rounded-lg shadow-lg hover:shadow-xl transition-shadow w-[300px] h-[300px]">
                                                       <img src={img7} className="w-full h-full object-cover transition-transform duration-500 hover:scale-105" />

                </div> 

                  <div className="rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-all duration-500 w-[300px] h-[300px]">
                                   <img src={img8} className="w-full h-full object-cover transition-transform duration-500 hover:scale-105" />
                               </div>


            </div>


           <div className="text-white mx-4 sm:mx-10 md:mx-[80px] font-sans leading-relaxed mt-10 sm:mt-14 md:mt-16">

                <h1 className="text-center text-2xl sm:text-3xl md:text-4xl font-extrabold mb-10 sm:mb-14 md:mb-16 
                    bg-gradient-to-r from-purple-400 to-blue-400 text-transparent bg-clip-text">
                    Design Documentation
                </h1>

                <div className="inline-grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-10">


                    <div className="p-6 sm:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-lg 
                        hover:scale-[1.02] transition duration-300 border border-white/10 
                        w-full max-w-[450px]">

                        <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-purple-300">
                            Brand Structure Guide
                        </h2>
                        <p className="text-base sm:text-lg md:text-xl mt-2 text-gray-200 leading-relaxed">
                            A document outlining the full structure of the brand — core elements, visual
                            system, communication pillars, audience hierarchy, and brand architecture rules.
                        </p>
                    </div>

                    <div className="p-6 sm:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-lg 
                        hover:scale-[1.02] transition duration-300 border border-white/10 
                        w-full max-w-[450px]">

                        <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-purple-300">
                            Brand Content Guidelines
                        </h2>
                        <p className="text-base sm:text-lg md:text-xl mt-2 text-gray-200 leading-relaxed">
                            Formal rules for writing all brand-related communication — messaging tone,
                            taglines, statements, copywriting style, captions, and verbal identity standards.
                        </p>
                    </div>

                    <div className="p-6 sm:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-lg 
                        hover:scale-[1.02] transition duration-300 border border-white/10 
                        w-full max-w-[450px]">

                        <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-purple-300">
                            Brand Design Framework
                        </h2>
                        <p className="text-base sm:text-lg md:text-xl mt-2 text-gray-200 leading-relaxed">
                            Detailed instructions on brand design elements — color system, typography,
                            graphic patterns, layout grids, visual components, and presentation rules.
                        </p>
                    </div>

                    <div className="p-6 sm:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-lg 
                        hover:scale-[1.02] transition duration-300 border border-white/10 
                        w-full max-w-[450px]">

                        <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-purple-300">
                            Brand Style Guide
                        </h2>
                        <p className="text-base sm:text-lg md:text-xl mt-2 text-gray-200 leading-relaxed">
                            Defines the brand’s visual and verbal personality — tone of voice, iconography,
                            spacing rules, image style, typography scales, and do’s & don’ts for consistency.
                        </p>
                    </div>

                    <div className="p-6 sm:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-lg 
                        hover:scale-[1.02] transition duration-300 border border-white/10 
                        w-full max-w-[450px]">

                        <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-purple-300">
                            Brand UI/UX Standards Manual
                        </h2>
                        <p className="text-base sm:text-lg md:text-xl mt-2 text-gray-200 leading-relaxed">
                            A guide for applying branding inside digital products — brand-driven UI
                            components, interaction styles, animations, responsive behavior, and accessibility.
                        </p>
                    </div>

                    <div className="p-6 sm:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-lg 
                        hover:scale-[1.02] transition duration-300 border border-white/10 
                        w-full max-w-[450px]">

                        <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-purple-300">
                            Brand Presentation Handbook
                        </h2>
                        <p className="text-base sm:text-lg md:text-xl mt-2 text-gray-200 leading-relaxed">
                            A compact document explaining how the brand appears in presentations — slides,
                            color usage, layout hierarchy, logo placement, and storytelling rules.
                        </p>
                    </div>

                    <div className="p-6 sm:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-lg 
                        hover:scale-[1.02] transition duration-300 border border-white/10 
                        w-full max-w-[450px]">

                        <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-purple-300">
                            Brand Component Library
                        </h2>
                        <p className="text-base sm:text-lg md:text-xl mt-2 text-gray-200 leading-relaxed">
                            A collection of reusable branded elements — icons, badges, buttons, layouts,
                            templates, backgrounds, and graphic components for consistent design.
                        </p>
                    </div>

                    <div className="p-6 sm:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-lg 
                        hover:scale-[1.02] transition duration-300 border border-white/10 
                        w-full max-w-[450px]">

                        <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-purple-300">
                            Brand Identity Manual
                        </h2>
                        <p className="text-base sm:text-lg md:text-xl mt-2 text-gray-200 leading-relaxed">
                            Explains the complete visual identity — logo usage, safe zones, typography
                            rules, imagery style, color application, and brand behavior across mediums.
                        </p>
                    </div>

                    <div className="p-6 sm:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-lg 
                        hover:scale-[1.02] transition duration-300 border border-white/10 
                        w-full max-w-[450px]">

                        <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-purple-300">
                            Brand Design System & Brand Identity
                        </h2>
                        <p className="text-base sm:text-lg md:text-xl mt-2 text-gray-200 leading-relaxed">
                            A unified system combining brand identity guidelines with structured design
                            system components for designers and developers.
                        </p>
                    </div>

                    <div className="p-6 sm:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-lg 
                        hover:scale-[1.02] transition duration-300 border border-white/10 
                        w-full max-w-[450px]">

                        <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-purple-300">
                            Brand Strategy Guide
                        </h2>
                        <p className="text-base sm:text-lg md:text-xl mt-2 text-gray-200 leading-relaxed">
                            A strategic document outlining brand purpose, vision, positioning, audience
                            insights, messaging framework, competitive landscape, and long-term roadmap.
                        </p>
                    </div>


                </div>

            </div>
        </>
    );
}

export default Branding;